(function ($) {


    // load plugins
    require('../jquery-plugins/swipebox.min.js');


    $( '.swipebox' ).swipebox( {
        useCSS : true, // false will force the use of jQuery for animations
        useSVG : false, // false to force the use of png for buttons
        initialIndexOnArray : 0, // which image index to init when a array is passed
        hideCloseButtonOnMobile : false, // true will hide the close button on mobile devices
        removeBarsOnMobile : false, // false will show top bar on mobile devices
        hideBarsDelay : 5000, // delay before hiding bars on desktop
        videoMaxWidth : 1140, // videos max width
        beforeOpen: function() {}, // called before opening
        afterOpen: null, // called after opening
        afterClose: function() {}, // called after closing
        loopAtEnd: false // true will return to the first image after the last image is reached
    } );



    $(window).bind("load", function () {
        var owlWynajem = $('.owl-carousel-offers').owlCarousel({
            loop: true,
            margin: 0,
            responsiveClass: true,
            dots: true,
            //dotsData: true,
            dotsEach: true,
            nav: false,
            responsive: {
                0: {
                    items: 1
                },
                535: {
                    items: 2
                },
                850: {
                    items: 2
                },
                1100: {
                    items: 2
                },
                1300: {
                    items: 3
                },
                1500: {
                    items: 3
                },
                1600: {
                    items: 4
                },
                2000: {
                    items: 4
                },
                2300: {
                    items: 5
                },
                2700: {
                    items: 6
                }
            }
        });

    });



})(jQuery);